import request from '@/utils/request'

export function getdistrict(data) {
  return request({
    url: '/system/district/list',
    method: 'get',
    params: data
  })
}
